import * as React from 'react'
import ServiceHolidayItem from '../../../../containers/services/ServiceHolidayItem'
import { IHolidayItem, IStoreState } from '../../../../types/index'

interface IServiceHolidaysProps {
  serviceId?: number
  orgId: number
  holidaysList: { [key: string]: IHolidayItem }
  onAddClick: (orgId: number, serviceId?: number) => void
}

class ServiceHolidays extends React.Component<IServiceHolidaysProps, IStoreState> {
  constructor(props: IServiceHolidaysProps) {
    super(props)
  }

  public render() {
    const { holidaysList, serviceId, orgId } = this.props

    return (
      <div>
        {Object.values(holidaysList).map(it => (
          <ServiceHolidayItem className='ServiceHolidayItem' key={`holiday-${it.id}`} holidayItem={it} />
        ))}
        <div
          className='add-holiday-btn cursor--pointer mt2 col-1 h5 font-blue-grey'
          onClick={this.handleAddClick(orgId, serviceId)}
        >
          + Add
        </div>
      </div>
    )
  }

  private handleAddClick = (orgId: number, serviceId?: number) => () => {
    this.props.onAddClick(orgId, serviceId)
  }
}

export default ServiceHolidays



// WEBPACK FOOTER //
// ./src/components/services/edit/holidays/ServiceHolidays.tsx